export const getFormattedDate = (date, dateFormat, showTimeInputs) => {
    if (!date || !date.isValid()) {
        return '';
    }
    const defaultDateFormat = showTimeInputs ? 'ddd, DD MMM, h:mm A' : 'ddd, DD MMM';
    const format = dateFormat || defaultDateFormat;
    return date.format(format);
};
